import React from 'react'
import Form from '../components/EmployerInfo/Form'
import NavBar from '../components/EmployerInfo/NavBar'
import Footer from '../components/Footer'

function EmployerInfo() {
  return (
    <div>
        <NavBar />
        <Form />
        <Footer />
    </div>
  )
}

export default EmployerInfo